import { Routes } from '@angular/router';

import { ListComponent } from './list/list.component';

import { AuthGuard } from '../auth.guard';
import { RootComponent } from '../root/root.component';

export const routing: Routes = [
  {
    path: 'workorder',
    data: {
      breadcrumb_en: 'Work Orders',
      breadcrumb_es: 'Òrdenes de Trabajo'
    },
    component: RootComponent, canActivate: [AuthGuard],

    children: [
      {
        path: '', component: ListComponent,
        data: {
          breadcrumb_en: 'Work Order List',
          breadcrumb_es: 'Lista de Òrdenes de Trabajo'
        }, },
      {
        path: 'list', component: ListComponent,
        data: {
          breadcrumb_en: 'Work Order List',
          breadcrumb_es: 'Lista de Òrdenes de Trabajo'
        },
      },
    ]
  }
];
